module.exports = __webpack_public_path__ + "static/nxrt-automotive9-94d7279d26b96aede4536b6126768873.jpg";